import { isNativeMobile, mobileDestination } from "mobile/nativeBridge"

export const getMeetingUrl = (meetingId: string, guestJoinUrl?: string | null) => {
  const path = `/meetings/${meetingId}`
  if (guestJoinUrl) {
    const origin = typeof window !== "undefined" ? window.location?.origin : ""
    try {
      const parsedUrl = new URL(guestJoinUrl, origin || "http://localhost")
      if (parsedUrl.pathname === path) {
        const sameOriginPath = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
        if (!origin) return sameOriginPath
        return new URL(sameOriginPath, origin).toString()
      }
    } catch {
      // Fall back to the legacy handling below for malformed values.
    }
    if (/^https?:\/\//i.test(guestJoinUrl)) return guestJoinUrl
    const guestPath = guestJoinUrl.startsWith("/") ? guestJoinUrl : `/${guestJoinUrl}`
    if (typeof window === "undefined" || !window.location?.origin) return guestPath
    return new URL(guestPath, window.location.origin).toString()
  }
  if (typeof window === "undefined" || !window.location?.origin) return path
  return new URL(path, window.location.origin).toString()
}

type MeetingEntry = {
  meetingId: string
  guestJoinUrl?: string | null
  navigate: (destination: string) => void
  // Keep each caller's established browser/external-window URL unchanged.
  windowTarget: string
}

/** Keep a matching meeting inside the native app without changing web link behavior. */
export function openMeetingEntry({ meetingId, guestJoinUrl, navigate, windowTarget }: MeetingEntry) {
  if (isNativeMobile()) {
    let destination: string | null = null
    try {
      const target = new URL(getMeetingUrl(meetingId, guestJoinUrl), window.location.origin)
      if (target.origin === window.location.origin && !target.username && !target.password
        && target.pathname === `/meetings/${meetingId}`) {
        destination = mobileDestination(`${target.pathname}${target.search}${target.hash}`)
      }
    } catch {
      // Invalid destinations retain the caller's existing window handling.
    }
    if (destination) {
      navigate(destination)
      return
    }
  }
  window.open(windowTarget, "_blank", "noopener,noreferrer")
}
